import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HdrOffSelectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hdr_off_select"}/>
}
